export default "__VITE_ASSET__B78vjLkU__"